"use strict";

exports.__esModule = true;
exports.Loop = void 0;

var _basic = require("./basic.js");

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _defaults(subClass, superClass); }

/**
 * Loop animation when mouse is on icon.
 */
var Loop = /*#__PURE__*/function (_Basic) {
  _inheritsLoose(Loop, _Basic);

  function Loop() {
    var _this;

    _this = _Basic.apply(this, arguments) || this;
    _this.playDelay = null;
    _this.active = false;
    return _this;
  }

  var _proto = Loop.prototype;

  _proto.connectedCallback = function connectedCallback() {
    _Basic.prototype.connectedCallback.call(this);

    this.target.addEventListener('mouseenter', this.enterBound);
    this.target.addEventListener('mouseleave', this.leaveBound);
  };

  _proto.disconnectedCallback = function disconnectedCallback() {
    this.resetPlayDelayTimer();
    this.target.removeEventListener('mouseenter', this.enterBound);
    this.target.removeEventListener('mouseleave', this.leaveBound);
    this.setDirection(1);

    _Basic.prototype.disconnectedCallback.call(this);
  };

  _proto.enter = function enter() {
    this.active = true;

    if (!this.inAnimation) {
      this.playFromBegining();
    }
  };

  _proto.leave = function leave() {
    this.active = false;
  };

  _proto.complete = function complete() {
    var _this2 = this;

    this.resetPlayDelayTimer();

    if (!this.active || !this.connected) {
      return;
    }

    if (this.delay > 0) {
      this.playDelay = setTimeout(function () {
        _this2.playFromBegining();
      }, this.delay);
    } else {
      this.playFromBegining();
    }
  };

  _proto.resetPlayDelayTimer = function resetPlayDelayTimer() {
    if (!this.playDelay) {
      return;
    }

    clearTimeout(this.playDelay);
    this.playDelay = null;
  };

  _createClass(Loop, [{
    key: "delay",
    get: function get() {
      return this.element.hasAttribute('delay') ? +(this.element.getAttribute('delay') || 0) : 0;
    }
  }]);

  return Loop;
}(_basic.Basic);

exports.Loop = Loop;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hbmltYXRpb25zL2xvb3AudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQTs7Ozs7Ozs7OztBQUVBOzs7SUFHYSxJOzs7QUFBYixrQkFBQTtBQUFBOzs7QUFDSSxVQUFBLFNBQUEsR0FBaUIsSUFBakI7QUFDQSxVQUFBLE1BQUEsR0FBUyxLQUFUO0FBRko7QUE4REM7Ozs7U0ExREcsaUIsR0FBQSw2QkFBaUI7QUFDYixxQkFBTSxpQkFBTjs7QUFFQSxTQUFLLE1BQUwsQ0FBWSxnQkFBWixDQUE2QixZQUE3QixFQUEyQyxLQUFLLFVBQWhEO0FBQ0EsU0FBSyxNQUFMLENBQVksZ0JBQVosQ0FBNkIsWUFBN0IsRUFBMkMsS0FBSyxVQUFoRDtBQUNILEc7O1NBRUQsb0IsR0FBQSxnQ0FBb0I7QUFDaEIsU0FBSyxtQkFBTDtBQUVBLFNBQUssTUFBTCxDQUFZLG1CQUFaLENBQWdDLFlBQWhDLEVBQThDLEtBQUssVUFBbkQ7QUFDQSxTQUFLLE1BQUwsQ0FBWSxtQkFBWixDQUFnQyxZQUFoQyxFQUE4QyxLQUFLLFVBQW5EO0FBRUEsU0FBSyxZQUFMLENBQWtCLENBQWxCOztBQUVBLHFCQUFNLG9CQUFOO0FBQ0gsRzs7U0FFRCxLLEdBQUEsaUJBQUs7QUFDRCxTQUFLLE1BQUwsR0FBYyxJQUFkOztBQUVBLFFBQUksQ0FBQyxLQUFLLFdBQVYsRUFBdUI7QUFDbkIsV0FBSyxnQkFBTDtBQUNIO0FBQ0osRzs7U0FFRCxLLEdBQUEsaUJBQUs7QUFDRCxTQUFLLE1BQUwsR0FBYyxLQUFkO0FBQ0gsRzs7U0FFRCxRLEdBQUEsb0JBQVE7QUFBQTs7QUFDSixTQUFLLG1CQUFMOztBQUVBLFFBQUksQ0FBQyxLQUFLLE1BQU4sSUFBZ0IsQ0FBQyxLQUFLLFNBQTFCLEVBQXFDO0FBQ2pDO0FBQ0g7O0FBRUQsUUFBSSxLQUFLLEtBQUwsR0FBYSxDQUFqQixFQUFvQjtBQUNoQixXQUFLLFNBQUwsR0FBaUIsVUFBVSxDQUFDLFlBQUs7QUFDN0IsUUFBQSxNQUFJLENBQUMsZ0JBQUw7QUFDSCxPQUYwQixFQUV4QixLQUFLLEtBRm1CLENBQTNCO0FBR0gsS0FKRCxNQUlPO0FBQ0gsV0FBSyxnQkFBTDtBQUNIO0FBQ0osRzs7U0FFRCxtQixHQUFBLCtCQUFtQjtBQUNmLFFBQUksQ0FBQyxLQUFLLFNBQVYsRUFBcUI7QUFDakI7QUFDSDs7QUFFRCxJQUFBLFlBQVksQ0FBQyxLQUFLLFNBQU4sQ0FBWjtBQUNBLFNBQUssU0FBTCxHQUFpQixJQUFqQjtBQUNILEc7Ozs7d0JBRVE7QUFDTCxhQUFPLEtBQUssT0FBTCxDQUFhLFlBQWIsQ0FBMEIsT0FBMUIsSUFBcUMsRUFBRSxLQUFLLE9BQUwsQ0FBYSxZQUFiLENBQTBCLE9BQTFCLEtBQXNDLENBQXhDLENBQXJDLEdBQWtGLENBQXpGO0FBQ0g7Ozs7RUE3RHFCLFkiLCJzb3VyY2VSb290IjoiIn0=